$shm_hitalama_text_table $mol_grid
	Table $shm_hitalama_text_table_body
		sub <= rows
